import app, { update } from '../app/app.js'

export default (f) => {
  const { isOnline, sessionAuth } = app()
  if (isOnline) {
    f()
  } else if (sessionAuth) {
    update(onlineCallback, f)
  } else {
    console.error('defer function: offline and not authenticated')
  }
}
